import React from 'react'

function WhychooseUs() {
    return (
        <div>

            <>
                {/* Start Work Area  */}
                <div className="work-area work-style-one tmp-section-gap">
                    <div className="container wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".3s">
                        <div className="row">
                            <div className="work-top-inner">
                                <div className="section-head pb-0 section-head-one-side text-align-left">
                                    <div className="section-sub-title color-white ">
                                        <span className="subtitle">WHY AQ AUDITING</span>
                                    </div>
                                    <h2 className="title color-white split-collab">
                                        We work with you to strengthen <br /> your financial foundation
                                    </h2>
                                </div>
                                <div
                                    className="single-work-top"
                                    data-sal-delay={250}
                                    data-sal="slide-up"
                                    data-sal-duration={800}
                                >
                                    <h2 className="title">1K+</h2>
                                    <div className="sub-title">Businesses Trust AQ Audit</div>
                                </div>
                                <div className="scater-line">
                                    <img src="assets/images/work/shape.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="row g-5">
                            <div
                                className="col-lg-6 col-md-6"
                                data-sal-delay={150}
                                data-sal="slide-up"
                                data-sal-duration={800}
                            >
                                <div className="inner">
                                    <a href="#">
                                        <div className="thumbnail">
                                            <img
                                                className="large"
                                                src="assets/images/work/works.jpg"
                                                alt="Business Consulting"
                                            />
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div
                                className="col-lg-3 col-md-6"
                                data-sal-delay={250}
                                data-sal="slide-up"
                                data-sal-duration={800}
                            >
                                <div className="single-work style-one mt--35">
                                    <a href="#">
                                        <div className="work-inner">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/work/consultation.png"
                                                    alt="Business Consulting"
                                                />
                                            </div>
                                            <h3 className="title">Fresh Perspective, Proven Expertise</h3>
                                            <p style={{textAlign:"justify"}} className="description">
                                                “As a dynamic new firm, we bring fresh perspective, up-to-date knowledge, and
                                                unwavering dedication to every client. Our team combines professional
                                                qualifications with real-world experience to deliver tailored, high-quality services
                                                without the bureaucracy.”

                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div
                                className="col-lg-3 col-md-12"
                                data-sal-delay={350}
                                data-sal="slide-up"
                                data-sal-duration={800}
                            >
                                <div className="single-work style-one">
                                    <a href="#" className="cart-box cart-box-1">
                                        <div className="work-inner">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/work/consultation.png"
                                                    alt="Business Consulting"
                                                />
                                            </div>
                                            <h3 className="title">Client-Centric Approach</h3>
                                            {/* <p className="description">
                                                We tailor every service to match your specific business goals and challenges.


                                            </p> */}
                                        </div>
                                    </a>
                                </div>
                                <div className="single-work style-one mt--30">
                                    <a href="#">
                                        <div className="work-inner">
                                            <div className="thumbnail">
                                                <img
                                                    src="assets/images/work/consultation.png"
                                                    alt="Business Consulting"
                                                />
                                            </div>
                                            <h3 className="title">Expertise that Matters</h3>
                                            {/* <p className="description">
                                                Decades of combined experience in audit, VAT, ERP, and financial services.



                                            </p> */}
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Work Area  */}
            </>

        </div>
    )
}

export default WhychooseUs